/* ANCO.AI — popola dinamicamente la sezione "Contenuti" leggendo il feed
   JSON del blog (rigenerato automaticamente da build_blog_post.py ad ogni
   pubblicazione). Nessun dato hardcoded: se il feed non risponde, mostra un
   messaggio d'errore invece di contenuti inventati. */
(() => {
  const containers = document.querySelectorAll('[data-ancoai-blog]');
  if (!containers.length) return;

  function buildCard(post, fallbackImage, feedOrigin) {
    const a = document.createElement('a');
    a.className = 'ancoai-blog-card';
    // post.url/post.image sono percorsi relativi al sito del blog
    // (official.ancoaigroup.com), non alla pagina Shopify che li ospita:
    // vanno risolti contro l'origine del feed, altrimenti puntano a un
    // percorso inesistente sul dominio dello store (404).
    a.href = new URL(post.url, feedOrigin).href;

    const media = document.createElement('div');
    media.className = 'ancoai-blog-card__media';

    const img = document.createElement('img');
    img.src = new URL(post.image || fallbackImage, feedOrigin).href;
    img.alt = post.title || '';
    img.loading = 'lazy';
    img.width = 400;
    img.height = 240;
    media.appendChild(img);

    const title = document.createElement('h4');
    title.className = 'ancoai-blog-card__title';
    title.textContent = post.title || '';

    a.appendChild(media);
    a.appendChild(title);
    return a;
  }

  containers.forEach(async (container) => {
    const feedUrl = container.dataset.feedUrl;
    const count = parseInt(container.dataset.count, 10) || 3;
    const fallbackImage = container.dataset.fallbackImage || '';
    if (!feedUrl) return;

    try {
      const feedOrigin = new URL(feedUrl).origin;
      const res = await fetch(feedUrl, { cache: 'no-store' });
      if (!res.ok) throw new Error('feed unavailable');
      const posts = await res.json();
      if (!Array.isArray(posts) || posts.length === 0) return;

      const latest = [...posts]
        .sort((a, b) => (a.date < b.date ? 1 : -1))
        .slice(0, count);

      const grid = document.createElement('div');
      grid.className = 'ancoai-blog-card-grid';
      latest.forEach((post) => grid.appendChild(buildCard(post, fallbackImage, feedOrigin)));

      container.innerHTML = '';
      container.appendChild(grid);
    } catch (err) {
      container.innerHTML =
        '<p class="ancoai-blog-grid__error">Non è stato possibile caricare gli ultimi articoli in questo momento.</p>';
    }
  });
})();
